module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAA3CAMAAACfBSJ0AAAAUVBMVEXv7+/v7+/v7+/v7+/v7+/v7+/v7+9HcEzv7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7+/v7++Hh4e90rRSAAAAGnRSTlO4AklMYmEBAFdWLFyjgH9KpaSFKAknCAdIRxUidogAAACVSURBVEjH7da7DoMwDIXhk6Q4LSHc6SXv/6DUhZEhttQFcvZvsmT98Dxa7CNvdqGfACvXIH+No829WsjWPtlRhHSRvs5BPudhBoXrDWpoVsOqnMVd5YLSVcWd16VU3IVcOtg/XbnDxV35u6d1Qd0v2l7S9pm2B70ZxWw03LuztHfjvPf1R9TX772vWU5duOUsdNPW8ys4cA98zFvWgAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/styles/common/img/plus.png
// module id = zEwT
// module chunks = 37